<div class="main-container d-flex align-items-center justify-content-center">
  <div class="content-wrapper">
    <!-- Logo centrado arriba -->
    <div class="img-documents-container text-center mb-4">
      <img src="../../../../assets/images/logo-dark.png" alt="Logo" />
    </div>

    <!-- Contenedor principal de la orden -->
    <div
      class="download-documents-container col-8 mx-auto"
      *ngIf="!isLoading && !errorMessage"
    >
      <div class="order-card">
        <!-- Header con información del cliente -->
        <div class="back">
          <div class="div-title">
            <h2 class="client-name">
              {{ orderData?.client?.name }} {{ orderData?.client?.lastname }}
            </h2>

            <!-- Etiquetas superiores -->
            <div *ngIf="showImportantDates" class="div-clocks text-secondary">
              <span class="clocks" *ngFor="let clock of clocks">
                <i class="icon-clock"></i>
                {{ "badge-status_select-stage." + clock.key | translate }}
                {{ clock.value }}
              </span>
            </div>
            <span
              *ngIf="orderData?.campaign_id"
              class="badge text-badge"
              [ngClass]="'campaign' | badgeClient"
            >
              <i
                class="icon-bullhorn text-sm"
                class="icon-white"
              ></i>
              {{ orderData?.campaign_name }}
            </span>
            <span
              class="badge text-badge"
              [ngClass]="stage | badgeColor:orderData.require_action:orderData.priority"
            >
              {{ "badge-status_select-stage." + stage | translate }}
            </span>
            <span
              *ngIf="orderData.client?.name"
              class="badge text-badge"
              [ngClass]="orderData.client?.type | badgeClient"
            >
              {{ "inputs." + orderData.client?.type | translate }}
            </span>
            <span
              *ngIf="orderData?.guarantee?.name"
              class="badge text-badge"
              [ngClass]="'guarantee' | badgeClient"
            >
              {{ "inputs.with_guarantee" | translate }}
            </span>
          </div>
        </div>

        <hr />
        <div class="row linea"></div>
        <!-- Datos del vehículo -->
        <div class="vehicle-container-info">
          <div class="vehicle-info col-6">
            <div class="model-brand">
              {{ orderData?.vehicle_brand }} {{ orderData?.vehicle_model }}
            </div>
            <div class="model">{{ orderData?.vehicle }}</div>
            <span
              *ngIf="orderData?.vehicle_status"
              class="badge text-badge-list"
              [ngClass]="orderData.vehicle_status | badgeVehicle"
            >
              {{
                "badge-status_select-stage." + orderData?.vehicle_status
                  | translate
              }}
            </span>
            <div class="details">
              <span
                class="badge"
                [ngClass]="{
                  new: orderData?.vehicle_status === 'new',
                  used: orderData?.vehicle_status === 'used',
                }"
              >
                {{ orderData?.vehicle_status === "new" ? "Nuevo" : "Usado" }}
              </span>
              <div class="vehicle-items">
                <span class="icon-brush2"></span
                ><span>{{ orderData?.colour }}</span>
              </div>
              <div class="vehicle-items">
                <span>{{ orderData?.duration }} meses</span>
              </div>
              <div class="vehicle-items">
                <span>{{ orderData?.total_kms }} kms</span>
              </div>
              <div class="vehicle-items">
                <span class="icon-coin-euro"></span>
                <span>{{ orderData?.monthly_fee_total }} €/mes</span>
              </div>
            </div>
          </div>

          <div class="references col-6">
            <div class="ref-block">
              <div class="ref-label">{{ orderData?.broker?.name }}</div>
              <div class="ref-value" *ngIf="orderData?.broker_reference">
                <i class="icon-barcode"></i> {{ orderData?.broker_reference }}
              </div>
            </div>
            <div class="ref-block">
              <div class="ref-label">{{ orderData?.supplier?.name }}</div>
              <div class="ref-value" *ngIf="orderData?.supplier_reference">
                <i class="icon-barcode"></i>{{ orderData?.supplier_reference }}
              </div>
            </div>
            <div class="ref-block">
              <div class="ref-label">{{ orderData?.vendor?.name }}</div>
              <div class="ref-value" *ngIf="orderData?.vendor_quote_reference">
                <i class="icon-barcode"></i>
                {{ orderData?.vendor_quote_reference }}
              </div>
              <div class="ref-value" *ngIf="orderData?.vendor_reference">
                <i class="icon-barcode"></i>{{ orderData?.vendor_reference }}
              </div>
            </div>
          </div>
        </div>

        <hr />
        <div class="row linea"></div>

        <!-- Offer pending: button to view client data -->
        <div class="offer-action-row" *ngIf="isOfferPending()">
          <button class="btn btn-primary" type="button" (click)="viewClientData()">
            {{ 'buttons.view_client_data' | translate }}
          </button>
        </div>

        <!-- Offer requested: upload offer form -->
        <div class="offer-upload-section" *ngIf="isOfferRequested()">
          <div class="offer-upload-card">
            <h6>{{ 'buttons.upload_offer' | translate }}</h6>
            <div class="offer-upload-form">
              <input type="file" class="form-control" (change)="onOfferFileSelected($event)"
                accept=".pdf,.jpg,.jpeg,.png,.csv,.txt,.docx,.doc,.xls,.xlsx,.zip,.rar" />
              <button class="btn btn-primary" type="button" [disabled]="!offerFile || offerUploading" (click)="uploadOffer()">
                <span *ngIf="!offerUploading">{{ 'buttons.upload' | translate }}</span>
                <span *ngIf="offerUploading" class="spinner-border spinner-border-sm" role="status"></span>
              </button>
            </div>
            <small class="text-danger" *ngIf="offerUploadError">{{ offerUploadError }}</small>
            <small class="text-muted">{{ 'inputs.max_file_size' | translate }}: 15 MB</small>
          </div>
        </div>

        <div class="action-section">
          <div class="documents-section">
            <div *ngIf="!showClientInfo" class="initial-section">
              <p class="info-message">
                {{ getInitialMessage() | translate }}
              </p>
              <div class="document-item mt-3">
                <button
                  class="btn btn-primary btn-primary-form"
                  (click)="handleButtonAction()"
                >
                  {{ getButtonText() | translate }}
                </button>
              </div>
            </div>

            <!-- Documentos públicos del pedido -->
            <div
              *ngIf="showClientInfo && hasOrderDocuments()"
              class="documents-list mb-4"
            >
              <div>
                <app-form-documents
                  [activeForm]="activeForm"
                  [orderData]="orderData"
                  [btn_submit]="false"
                  [readOnlyMode]="true"
                >
                </app-form-documents>
              </div>
              <hr />
            </div>

            <div
              *ngIf="showClientInfo && orderData?.client"
              class="client-info-section"
            >
              <!-- <h5 class="title-showinfo">Titular</h5> -->
              <h5 class="title-showinfo">
                {{ getClientTitle() }}
              </h5>
              <div class="row" [hidden]="orderData.client && step == 2">
                <div class="col-6">
                  <div class="column-list">
                    <label>{{ "inputs.client" | translate }}</label>
                    <div class="input-group div-copy">
                      <input
                        type="text"
                        class="form-control"
                        disabled
                        [value]="
                          orderData.client?.name +
                          ' ' +
                          orderData.client?.lastname
                        "
                        #inputClientName
                      />
                      <div class="input-group-append">
                        <button
                          class="btn btn-outline-secondary copy"
                          type="button"
                          (click)="
                            copyToClipboard(inputClientName.value, $event)
                          "
                        >
                          <i class="icon-copy"></i>
                        </button>
                      </div>
                    </div>
                    <!-- <div class="column-list"> -->
                    <label>{{ "inputs.identification" | translate }}</label>
                    <div class="input-group div-copy">
                      <input
                        type="text"
                        class="form-control"
                        disabled
                        [value]="orderData.client?.tax_id"
                        #inputFieldtax_id
                      />
                      <div class="input-group-append">
                        <button
                          class="btn btn-outline-secondary copy"
                          type="button"
                          (click)="
                            copyToClipboard(inputFieldtax_id.value, $event)
                          "
                        >
                          <i class="icon-copy"></i>
                        </button>
                      </div>
                    </div>

                    <label>{{ "inputs.contact" | translate }}</label>
                    <div class="input-group div-copy">
                      <input
                        type="text"
                        class="form-control"
                        disabled
                        [value]="orderData.client?.email"
                        #inputFieldemail
                      />
                      <div class="input-group-append">
                        <button
                          class="btn btn-outline-secondary copy"
                          type="button"
                          (click)="
                            copyToClipboard(inputFieldemail.value, $event)
                          "
                        >
                          <i class="icon-copy"></i>
                        </button>
                      </div>
                    </div>
                    <label>{{ "inputs.phone" | translate }}</label>
                    <div class="input-group div-copy">
                      <input
                        type="text"
                        class="form-control"
                        disabled
                        [value]="orderData.client?.phone"
                        #inputFieldphone
                      />
                      <div class="input-group-append">
                        <button
                          class="btn btn-outline-secondary copy"
                          type="button"
                          (click)="
                            copyToClipboard(inputFieldphone.value, $event)
                          "
                        >
                          <i class="icon-copy"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-6">
                  <div class="column-list">
                    <label>{{ "inputs.direction" | translate }}</label>
                    <div class="input-group div-copy">
                      <input
                        type="text"
                        class="form-control"
                        disabled
                        [value]="orderData.client?.billing_address"
                        #inputFieldbilling_address
                      />
                      <div class="input-group-append">
                        <button
                          class="btn btn-outline-secondary copy"
                          type="button"
                          (click)="
                            copyToClipboard(inputFieldbilling_address.value, $event)
                          "
                        >
                          <i class="icon-copy"></i>
                        </button>
                      </div>
                    </div>

                    <label>{{
                      "inputs.billing_postal_code" | translate
                    }}</label>
                    <div class="input-group div-copy">
                      <input
                        type="text"
                        class="form-control"
                        disabled
                        [value]="orderData.client?.billing_postal_code"
                        #inputFieldbilling_postal_code
                      />
                      <div class="input-group-append">
                        <button
                          class="btn btn-outline-secondary copy"
                          type="button"
                          (click)="
                            copyToClipboard(inputFieldbilling_postal_code.value, $event)
                          "
                        >
                          <i class="icon-copy"></i>
                        </button>
                      </div>
                    </div>

                    <label>{{ "inputs.billing_state" | translate }}</label>
                    <div class="input-group div-copy">
                      <input
                        type="text"
                        class="form-control"
                        disabled
                        [value]="orderData.client?.billing_state"
                        #inputFieldbilling_state
                      />
                      <div class="input-group-append">
                        <button
                          class="btn btn-outline-secondary copy"
                          type="button"
                          (click)="
                            copyToClipboard(inputFieldbilling_state.value, $event)
                          "
                        >
                          <i class="icon-copy"></i>
                        </button>
                      </div>
                    </div>

                    <label>{{ "inputs.billing_city" | translate }}</label>
                    <div class="input-group div-copy">
                      <input
                        type="text"
                        class="form-control"
                        disabled
                        [value]="orderData.client?.billing_city"
                        #inputFieldbilling_city
                      />
                      <div class="input-group-append">
                        <button
                          class="btn btn-outline-secondary copy"
                          type="button"
                          (click)="
                            copyToClipboard(inputFieldbilling_city.value, $event)
                          "
                        >
                          <i class="icon-copy"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="input-group justify-content-end mt-2">
                  <label class="text_add" (click)="step = 2">
                    {{ "inputs.next" | translate }} >
                    <!-- <i class="icon-arrow-right btn-next"></i> -->
                  </label>
                </div>
              </div>

              <div [hidden]="orderData.client && step == 1">
                <form [formGroup]="clientFormExtra">
                  <div class="row">
                    <div class="col-6">
                      <div class="column-list">
                        <label for="client_gender" class="form-label">{{ "inputs.client_gender" | translate }}</label>
                        <div class="input-group div-copy">
                          <select
                            id="client_gender"
                            class="form-control"
                            formControlName="client_gender"
                          >
                            <option value="" disabled selected>
                              {{ "inputs.select_option" | translate }}
                            </option>
                            <option value="male">
                              {{ "inputs.gender.male" | translate }}
                            </option>
                            <option value="female">
                              {{ "inputs.gender.female" | translate }}
                            </option>
                          </select>
                        </div>
                        <!-- </div> -->

                        <!--  <div class="column-list"> -->
                        <label for="client_marital_status" class="form-label">{{
                          "inputs.client_marital_status" | translate
                        }}</label>
                        <div class="input-group div-copy">
                          <select
                            id="client_marital_status"
                            class="form-control"
                            formControlName="client_marital_status"
                          >
                            <option value="" disabled selected>
                              {{ "inputs.select_option" | translate }}
                            </option>
                            <option value="single">
                              {{ "inputs.marital_status.single" | translate }}
                            </option>
                            <option value="married">
                              {{ "inputs.marital_status.married" | translate }}
                            </option>
                            <option value="divorced">
                              {{ "inputs.marital_status.divorced" | translate }}
                            </option>
                            <option value="separated">
                              {{
                                "inputs.marital_status.separated" | translate
                              }}
                            </option>
                            <option value="widowed">
                              {{ "inputs.marital_status.widowed" | translate }}
                            </option>
                          </select>
                        </div>
                        <!-- </div> -->
                        <!-- <div class="column-list"> -->
                        <label for="client_housing_type" class="form-label">{{
                          "inputs.client_housing_type" | translate
                        }}</label>

                        <div class="input-group div-copy">
                          <select
                            id="client_housing_type"
                            class="form-control"
                            formControlName="client_housing_type"
                          >
                            <option value="" disabled selected>
                              {{ "inputs.select_option" | translate }}
                            </option>
                            <option value="rented">
                              {{ "inputs.housing_type.rented" | translate }}
                            </option>
                            <option value="owned_deeded">
                              {{
                                "inputs.housing_type.owned_deeded" | translate
                              }}
                            </option>
                            <option value="owned_not_deeded">
                              {{
                                "inputs.housing_type.owned_not_deeded"
                                  | translate
                              }}
                            </option>
                            <option value="family_home">
                              {{
                                "inputs.housing_type.family_home" | translate
                              }}
                            </option>
                            <option value="other">
                              {{ "inputs.housing_type.other" | translate }}
                            </option>
                          </select>
                        </div>
                        <label>{{
                          "inputs.client_mounthly_net_income" | translate
                        }}</label>

                        <div class="input-group div-copy">
                          <input
                            type="text"
                            class="form-control"
                            [value]="orderData.client_monthly_net_income"
                            #inputFieldclientMounthlyNetIncome
                            formControlName="client_monthly_net_income"
                          />
                          <div class="input-group-append">
                            <button
                              class="btn btn-outline-secondary copy"
                              type="button"
                              (click)="
                                copyToClipboard(inputFieldclientMounthlyNetIncome.value, $event)
                              "
                            >
                              <i class="icon-copy"></i>
                            </button>
                          </div>
                        </div>
                        <label>{{
                          "inputs.client_employer_postal_code" | translate
                        }}</label>

                        <div class="input-group div-copy">
                          <input
                            type="text"
                            class="form-control"
                            [value]="orderData.client_employer_postal_code"
                            #inputFieldclient_employer_postal_code
                            formControlName="client_employer_postal_code"
                          />
                          <div class="input-group-append">
                            <button
                              class="btn btn-outline-secondary copy"
                              type="button"
                              (click)="
                                copyToClipboard(inputFieldclient_employer_postal_code.value, $event)
                              "
                            >
                              <i class="icon-copy"></i>
                            </button>
                          </div>
                        </div>
                        <div class="input-group justify-content-start mt-2">
                          <label class="text_add" (click)="step = 1">
                            < {{ "inputs.back" | translate }}
                            <!-- <i class="icon-arrow-right btn-next"></i> -->
                          </label>
                        </div>
                      </div>
                    </div>

                    <div class="col-6">
                      <div class="column-list">
                        <label for="client_employment_situation" class="form-label">{{
                          "inputs.client_employment_situation" | translate
                        }}</label>

                        <div class="input-group div-copy">
                          <select
                            id="client_employment_situation"
                            class="form-control"
                            formControlName="client_employment_situation"
                          >
                            <option value="" disabled selected>
                              {{ "inputs.select_option" | translate }}
                            </option>
                            <option value="employee_permanent">
                              {{
                                "inputs.employment_situation.employee_permanent"
                                  | translate
                              }}
                            </option>
                            <option value="employee_temporary">
                              {{
                                "inputs.employment_situation.employee_temporary"
                                  | translate
                              }}
                            </option>
                            <option value="self_employed">
                              {{
                                "inputs.employment_situation.self_employed"
                                  | translate
                              }}
                            </option>
                            <option value="retired">
                              {{
                                "inputs.employment_situation.retired"
                                  | translate
                              }}
                            </option>
                            <option value="unemployed">
                              {{
                                "inputs.employment_situation.unemployed"
                                  | translate
                              }}
                            </option>
                            <option value="no_employment">
                              {{
                                "inputs.employment_situation.no_employment"
                                  | translate
                              }}
                            </option>
                          </select>
                        </div>

                        <label>{{
                          "inputs.client_employer_name" | translate
                        }}</label>

                        <div class="input-group div-copy">
                          <input
                            type="text"
                            class="form-control"
                            [value]="orderData.client_employer_name"
                            #inputFieldclientEmployerName
                            formControlName="client_employer_name"
                          />
                          <div class="input-group-append">
                            <button
                              class="btn btn-outline-secondary copy"
                              type="button"
                              (click)="
                                copyToClipboard(inputFieldclientEmployerName.value, $event)
                              "
                            >
                              <i class="icon-copy"></i>
                            </button>
                          </div>
                        </div>

                        <label>{{
                          "inputs.client_employer_tax_id" | translate
                        }}</label>

                        <div class="input-group div-copy">
                          <input
                            type="text"
                            class="form-control"
                            [value]="orderData.client_employer_tax_id"
                            #inputFieldclientEmployerTaxId
                            formControlName="client_employer_tax_id"
                          />
                          <div class="input-group-append">
                            <button
                              class="btn btn-outline-secondary copy"
                              type="button"
                              (click)="
                                copyToClipboard(inputFieldclientEmployerTaxId.value, $event)
                              "
                            >
                              <i class="icon-copy"></i>
                            </button>
                          </div>
                        </div>
                        <label
                          for="client_employer_from_date"
                          class="form-label"
                          >{{ "inputs.client_employer_from_date" | translate }}
                        </label>
                        <div class="input-group div-copy">
                          <mat-form-field appearance="fill">
                            <input
                              matInput
                              [matDatepicker]="client_employer_from_date"
                              formControlName="client_employer_from_date"
                              placeholder="{{
                                'inputs.client_employer_from_date' | translate
                              }}"
                            />
                            <mat-datepicker-toggle
                              matSuffix
                              [for]="client_employer_from_date"
                            ></mat-datepicker-toggle>
                            <mat-datepicker
                              #client_employer_from_date
                            ></mat-datepicker>
                          </mat-form-field>
                        </div>
                        <label>{{
                          "inputs.client_employer_address" | translate
                        }}</label>

                        <div class="input-group div-copy">
                          <input
                            type="text"
                            class="form-control"
                            [value]="orderData.client_employer_address"
                            #inputFieldclient_employer_address
                            formControlName="client_employer_address"
                          />
                          <div class="input-group-append">
                            <button
                              class="btn btn-outline-secondary copy"
                              type="button"
                              (click)="
                                copyToClipboard(inputFieldclient_employer_address.value, $event)
                              "
                            >
                              <i class="icon-copy"></i>
                            </button>
                          </div>
                        </div>
                        <label>{{
                          "inputs.client_bank_account" | translate
                        }}</label>

                        <div class="input-group div-copy">
                          <input
                            type="text"
                            class="form-control"
                            [value]="orderData.client_bank_account"
                            #inputFieldclient_bank_account
                            formControlName="client_bank_account"
                          />
                          <div class="input-group-append">
                            <button
                              class="btn btn-outline-secondary copy"
                              type="button"
                              (click)="
                                copyToClipboard(inputFieldclient_bank_account.value, $event)
                              "
                            >
                              <i class="icon-copy"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>

              <!-- Documentos públicos del cliente -->
              <div *ngIf="orderData?.client" class="documents-container">
                <app-form-documents
                  activeForm="client"
                  [clientData]="orderData.client"
                  [btn_submit]="false"
                  [readOnlyMode]="true"
                >
                </app-form-documents>
              </div>
              <hr *ngIf="showClientInfo && orderData.guarantee" />
            </div>

            <div class="row" *ngIf="showClientInfo && orderData.guarantee">
              <h5 class="title-showinfo">
                {{ "inputs.guarantee" | translate }}
              </h5>
              <div class="col-6">
                <div class="column-list">
                  <label>{{ "inputs.guarantee" | translate }}</label>
                  <div class="input-group div-copy">
                    <input
                      type="text"
                      class="form-control"
                      disabled
                      [value]="
                        orderData.guarantee?.name +
                        ' ' +
                        orderData.guarantee?.lastname
                      "
                      #inputGuaranteeName
                    />
                    <div class="input-group-append">
                      <button
                        class="btn btn-outline-secondary copy"
                        type="button"
                        (click)="
                          copyToClipboard(inputGuaranteeName.value, $event)
                        "
                      >
                        <i class="icon-copy"></i>
                      </button>
                    </div>
                  </div>

                  <!-- <div class="column-list"> -->
                  <label>{{ "inputs.identification" | translate }}</label>
                  <div class="input-group div-copy">
                    <input
                      type="text"
                      class="form-control"
                      disabled
                      [value]="orderData.guarantee?.tax_id"
                      #inputFieldGuaranteetax_id
                    />
                    <div class="input-group-append">
                      <button
                        class="btn btn-outline-secondary copy"
                        type="button"
                        (click)="
                          copyToClipboard(inputFieldGuaranteetax_id.value, $event)
                        "
                      >
                        <i class="icon-copy"></i>
                      </button>
                    </div>
                  </div>
                  <!-- </div> -->
                  <!-- <div class="column-list"> -->
                  <label>{{ "inputs.contact" | translate }}</label>

                  <div class="input-group div-copy">
                    <input
                      type="text"
                      class="form-control"
                      disabled
                      [value]="orderData.guarantee?.email"
                      #inputFieldGuaranteeemail
                    />
                    <div class="input-group-append">
                      <button
                        class="btn btn-outline-secondary copy"
                        type="button"
                        (click)="
                          copyToClipboard(inputFieldGuaranteeemail.value, $event)
                        "
                      >
                        <i class="icon-copy"></i>
                      </button>
                    </div>
                  </div>
                  <label>{{ "inputs.phone" | translate }}</label>

                  <div class="input-group div-copy">
                    <input
                      type="text"
                      class="form-control"
                      disabled
                      [value]="orderData.guarantee?.phone"
                      #inputFieldGuaranteephone
                    />
                    <div class="input-group-append">
                      <button
                        class="btn btn-outline-secondary copy"
                        type="button"
                        (click)="
                          copyToClipboard(inputFieldGuaranteephone.value, $event)
                        "
                      >
                        <i class="icon-copy"></i>
                      </button>
                    </div>
                  </div>
                  <!-- </div> -->
                </div>
              </div>
              <div class="col-6">
                <div class="column-list">
                  <label for="guarantee_relationship" class="form-label">{{
                    "inputs.guarantee_relationship" | translate
                  }}</label>

                  <div class="input-group div-copy">
                    <input
                      type="text"
                      class="form-control"
                      disabled
                      [value]="orderData?.guarantee_relationship"
                      #inputgGarantee_relationship
                    />
                    <div class="input-group-append">
                      <button
                        class="btn btn-outline-secondary copy"
                        type="button"
                        (click)="
                          copyToClipboard(inputgGarantee_relationship.value, $event)
                        "
                      >
                        <i class="icon-copy"></i>
                      </button>
                    </div>
                  </div>

                  <label>{{ "inputs.direction" | translate }}</label>

                  <div class="input-group div-copy">
                    <input
                      type="text"
                      class="form-control"
                      disabled
                      [value]="orderData.guarantee?.billing_address"
                      #inputFieldGuaranteebilling_address
                    />
                    <div class="input-group-append">
                      <button
                        class="btn btn-outline-secondary copy"
                        type="button"
                        (click)="
                          copyToClipboard(inputFieldGuaranteebilling_address.value, $event)
                        "
                      >
                        <i class="icon-copy"></i>
                      </button>
                    </div>
                  </div>

                  <label>{{ "inputs.billing_postal_code" | translate }}</label>

                  <div class="input-group div-copy">
                    <input
                      type="text"
                      class="form-control"
                      disabled
                      [value]="orderData.guarantee?.billing_postal_code"
                      #inputFieldGuaranteebilling_postal_code
                    />
                    <div class="input-group-append">
                      <button
                        class="btn btn-outline-secondary copy"
                        type="button"
                        (click)="
                          copyToClipboard(inputFieldGuaranteebilling_postal_code.value, $event)
                        "
                      >
                        <i class="icon-copy"></i>
                      </button>
                    </div>
                  </div>
                  <label>{{ "inputs.billing_state" | translate }}</label>

                  <div class="input-group div-copy">
                    <input
                      type="text"
                      class="form-control"
                      disabled
                      [value]="orderData.guarantee?.billing_state"
                      #inputFieldGuaranteebilling_state
                    />
                    <div class="input-group-append">
                      <button
                        class="btn btn-outline-secondary copy"
                        type="button"
                        (click)="
                          copyToClipboard(inputFieldGuaranteebilling_state.value, $event)
                        "
                      >
                        <i class="icon-copy"></i>
                      </button>
                    </div>
                  </div>
                  <label>{{ "inputs.billing_city" | translate }}</label>

                  <div class="input-group div-copy">
                    <input
                      type="text"
                      class="form-control"
                      disabled
                      [value]="orderData.guarantee?.billing_city"
                      #inputFieldGuaranteebilling_city
                    />
                    <div class="input-group-append">
                      <button
                        class="btn btn-outline-secondary copy"
                        type="button"
                        (click)="
                          copyToClipboard(inputFieldGuaranteebilling_city.value, $event)
                        "
                      >
                        <i class="icon-copy"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div
                *ngIf="orderData?.guarantee"
                class="documents-container mt-4"
              >
                <app-form-documents
                  activeForm="guarantee"
                  [guaranteeData]="orderData.guarantee"
                  [btn_submit]="false"
                  [readOnlyMode]="true"
                >
                </app-form-documents>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="isLoading" class="loading text-center">Cargando...</div>
      <div *ngIf="errorMessage" class="error text-center">
        {{ errorMessage }}
      </div>
    </div>
  </div>
</div>
